export const BASE_URL = '';

export const QUESTION_PATH = '/api/answer/';

export const ReqMethod = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
};

export const Buttons = {
  enter: 'Enter',
};
